import AxiosAPI from "@qualitas/libs";
import { AxiosResponse } from "axios";

import { TemplateAdministrationInstitutionVehicleUpsert } from "../Models";

export const PlacementAgentsAdminAPI = (baseURL: string | undefined, clientId: string) => {
	const api = AxiosAPI({
		baseURL,
		clientId,
		isApp: true,
		hasUnderMaintenance: false
	});

	const getAdministrationData = () => {
		const serviceUrl = `/bookbuilding-api/PlacementAgents/GetAdministrationData`;
		return api.get(serviceUrl)
			.then((response: AxiosResponse) => response.data)
			.catch((error: any) => error);
	};

	const saveAdministrationInstitutionVehicle = (data: TemplateAdministrationInstitutionVehicleUpsert) => {
		const serviceUrl = `/bookbuilding-api/PlacementAgents/SaveAdministrationInstitutionVehicle`;
		return api.post(serviceUrl, data)
			.then((response: AxiosResponse) => response.data)
			.catch((error: any) => error);
	};

	const deleteAdministrationInstitutionVehicle = (idInstitution: number, idVehicle: number) => {
		const serviceUrl = `/bookbuilding-api/PlacementAgents/DeleteAdministrationInstitutionVehicle`;
		return api.delete(serviceUrl, { params: { idInstitution, idVehicle } })
			.then((response: AxiosResponse) => response.data)
			.catch((error: any) => error);
	};

	return {
		getAdministrationData,
		saveAdministrationInstitutionVehicle,
		deleteAdministrationInstitutionVehicle
	};
};
